import React, {useEffect, useState} from 'react';
import {StyleSheet, View} from 'react-native';
import Localized from 'src/constants/AppStrings';
import {useDispatch} from 'react-redux';
import Styles from 'src/components/Styles';
import BackSubheader from 'src/components/elements/BackSubheader';
import ScanditView from 'src/components/elements/ScanditView';
import {
  fetchAccountBalances,
  scanGiftCard,
} from 'src/redux/slices/accountSlice';
import AccountStore from 'src/stores/AccountStore';
import ActionsFactory from 'src/actions/ActionsFactory';
import {alertError} from 'src/components/helpers/AlertHelper';
import FirebaseAnalytic from '../../../nativeModules/FirebaseAnalytic';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import {useAppSelector} from 'src/redux/hooks';
function AddEGiftCard() {
  const dispatch = useDispatch();
  const account = useAppSelector((s) => s.account?.account);
  const [scanning, setScanning] = useState(true);
  useEffect(() => {
    dispatch(fetchAccountBalances(account?.id));
  }, []);

  return (
    <BackSubheader
      title={Localized.Labels.add_egift_card}
      testId={'qa_AddeGift.PageTitle_txt'}
    >
      <View style={styles.scanCodeView} accessible>
        <ScanditView
          barcodeScanned={async (code) => {
            FirebaseAnalytic.trackEvent('barcodeScanned', 'AddEGiftCard', {
              code,
            });

            setScanning(false);
            if (code.indexOf('GMA:id:') !== -1) {
              const data = await dispatch(
                scanGiftCard({
                  code: code.replace('GMA:id:', ''),
                  callback: () =>
                    ActionsFactory.getAccountActions().reloadConsumerData({
                      accountId: AccountStore.getAccountId(),
                      accountBalanceId: AccountStore.getAccountBalanceId(),
                      email: AccountStore.getEmail(),
                      userInitiated: true,
                    }),
                }),
              );

              if (data['payload'] && data['payload']['isSuccess'] == false) {
                setScanning(true);
              }
              if (data['payload'] && data['payload']['isSmaRestrict'] == true) {
                NavActions.navigate(AppRoutes.ServerErrorDialog, {
                  errorTitle: Localized.Errors.egift_card_message,
                  errorDesc: Localized.Errors.egift_card_desc,
                });
                return;
              }
            } else {
              alertError(Localized.Errors.error_scanning_qr_code, '', () => {
                setScanning(true);
              });
            }
          }}
          scanning={scanning}
          style={styles.scanCode}
        />
      </View>
    </BackSubheader>
  );
}

const styles = StyleSheet.create({
  scanCodeView: {
    flex: 1,
    backgroundColor: 'gray',
    margin: Styles.Spacing.m4,
    borderRadius: Styles.Spacing.m4,
    overflow: 'hidden',
  },
  scanCode: {flex: 1},
});

export default AddEGiftCard;
